<template>
  <j-modal
    :title="title"
    :width="modelStyle.width"
    :visible="visible"
    :bodyStyle ="bodyStyle"
    :switchFullscreen="switchFullscreen"
    @cancel="handleCancel"
    @setInnerFullscreen="setInnerFullscreen"
   >
    <template slot="footer">
      <div v-if="source == 'UserAnnouncementlist'&&record.needReply == '1'"><a-textarea v-model="sysAnnouncementSend.replyContent" :disabled="!!sysAnnouncementSend.replyUserId" :maxLength="150" style="width: 100%;margin-right: 8px;margin-bottom: 8px"/></div>
      <span style="padding-right: 10px" v-if="source == 'UserAnnouncementlist'&&record.needReply == '1'&&sysAnnouncementSend.replyUserId">
        {{language['system.announcement.replyTime']}} : {{sysAnnouncementSend.replyTime}}
      </span>
<!--      <a-button type="primary" v-if="source == 'UserAnnouncementlist'&&record.needReply == '1'" @click="replyAnnouncement">{{sysAnnouncementSend.replyContent?language['system.announcement.replyAgain']:language['common.reply'] }}</a-button>-->
      <a-button type="primary" v-if="source == 'UserAnnouncementlist'&&record.needReply == '1'&&!sysAnnouncementSend.replyUserId" @click="replyAnnouncement">{{language['common.reply'] }}</a-button>
      <a-button key="back" @click="handleCancel">{{language['common.closeButton']}}</a-button>
      <a-button v-if="record.openType==='url'" type="primary" @click="toHandle">{{language['announcement.dealWith']}}</a-button>
    </template>
    <a-card class="daily-article" :loading="loading">
      <a-card-meta
        :title="record.titile"
        :description="language['announcement.publisher']+'：'+(record.sender?record.sender:language['common.not']) +' | '+ language['announcement.publishTime']+'：' + (record.sendTime?record.sendTime:language['common.not'])">
      </a-card-meta>
      <a-divider />
      <span style="margin: 10px 0px">{{language['announcement.msgAbstract']}}:<span v-html="record.msgAbstract" class="article-content"></span></span>
      <span v-html="record.msgContent" class="article-content"></span>

      <div v-if="record.fileList && record.fileList.length > 0">
        <a-divider />
        <span>{{language['selfCheck.file']}}：</span>
        <div v-for="file in record.fileList" :key="file.id" :value="file.filePath">
          <a  @click="announcementDownloadFile(file)">{{file.fileName}}</a><!--:src="getAvatarView(file.filePath)"-->
        </div>
      </div>
    </a-card>
  </j-modal>
</template>

<script>
  import {getFileAccessHttpUrl,getAction,putAction} from '@/api/manage'
  export default {
    name: "SysAnnouncementModal",
    components: {
    },
    data () {
      return {
        title:this.$store.getters.language['announcement.title'],
        record: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        visible: false,
        switchFullscreen: true,
        loading: false,
        bodyStyle:{
          padding: "0",
          height:(window.innerHeight*0.65)+"px",
          "overflow-y":"auto",

        },
        modelStyle:{
          width: '60%',
          style: { top: '20px' },
          fullScreen: false
        },
        sysAnnouncementSend:{},
        source:'',
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
    },
    created () {
    },
    methods: {
      setInnerFullscreen(val){
        if(val){
          this.bodyStyle.height = (window.innerHeight*0.8)+'px'
        }else{
          this.bodyStyle.height = (window.innerHeight*0.65)+'px'
        }
      },
      announcementDownloadFile(file){
        let avatarView = this.getAvatarView(file.filePath);
        window.open(avatarView)
      },
      getAvatarView: function (avatar) {
        return getFileAccessHttpUrl(avatar,this.$store.getters.application.applicationCode)
      },
      Str_msgContent_toHttp(str){
        let windowURL = window._CONFIG['domianURL'];
        if(this.record.msgContent){
          let str = this.record.msgContent;
          return this.funreplace(str,'/*httpurl*/',windowURL);
        }
        return "";
      },
      funreplace(str,string,value){
        str = str.replace(string,value);
        if(str.indexOf(string)!=-1){
          str = this.funreplace(str,string,value)
        }
        return str;
      },
      detail (record,source) {
        this.visible = true;
        this.record = record;
        // this.record.msgContent = this.Str_msgContent_toHttp()
        if(source == "UserAnnouncementlist"){
          this.source = "UserAnnouncementlist"
          this.getReply();
        }
      },
      getReply(){
        this.sysAnnouncementSend = {}
        if(this.record.needReply == '1'){
          getAction("/sys/sysAnnouncementSend/queryByUserAndAnntId",{userId:this.$store.getters.userInfo.id,anntId:this.record.anntId}).then(res=>{
            if(res.success){
              this.sysAnnouncementSend = {...res.result};
            }
          })
        }
      },
      replyAnnouncement(){
        if(this.sysAnnouncementSend != {}&&this.sysAnnouncementSend.replyContent){
          let that = this
          this.$confirm({
            title: that.language["confirm.titleConfirmOperation"],
            content: that.language["common.submitConfirmInfo"],
            onOk: function () {
              putAction("/sys/sysAnnouncementSend/replyAnnouncement",that.sysAnnouncementSend).then(res=>{
                if(res.success){
                  // this.sysAnnouncementSend = res.result;
                  that.$message.success(that.language["operationSuccess"]);
                  that.visible = false;
                }else{
                  that.$message.error(that.language["common.errorContext"]);
                }
              })
            }
          })

        }
      },
      handleCancel () {
        this.visible = false;
      },
      /** 切换全屏显示 */
      handleClickToggleFullScreen() {
        let mode = !this.modelStyle.fullScreen
        if (mode) {
          this.modelStyle.width = '100%'
          this.modelStyle.style.top = '20px'
        } else {
          this.modelStyle.width = '60%'
          this.modelStyle.style.top = '50px'
        }
        this.modelStyle.fullScreen = mode
      },
      toHandle(){
        if(this.record.openType==='url'){
          this.visible = false;
          //链接跳转
          this.$router.push({path: this.record.openPage})
        }
      },
    }
  }
</script>

<style lang="less">
  .announcementCustomModal{
    .ant-modal-header {
      border: none;
      display: inline-block;
      position: absolute;
      z-index: 1;
      right: 56px;
      padding: 0;
      .ant-modal-title{
        .custom-btn{
          width: 56px;
          height: 56px;
          border: none;
          box-shadow: none;
        }
      }
    }
    .daily-article{
      border-bottom: 0;
    }
  }
</style>
<style scoped lang="less">
  .daily-article {
    .article-button {
      font-size: 1.2rem !important;
    }
    .ant-card-body {
      padding: 18px !important;
    }
    .ant-card-head {
      padding: 0 1rem;
    }
    .ant-card-meta {
      margin-bottom: 1rem;
    }
    .article-content {
      p {
        word-wrap: break-word;
        word-break: break-all;
        text-overflow: initial;
        white-space: normal;
        font-size: .9rem !important;
        margin-bottom: .8rem;
      }
    }
  }
</style>
